/**
 * @author NikolaV
 */

import * as React from 'react';
import { observer } from 'mobx-react';
import { Dropdown } from '@shared/ui-react/Dropdown';
import { DocumentsImagesStoreAbstract } from '@shared/documents-images/DocumentsImagesStoreAbstract';


@observer
export class DocumentsSettingsDropdown extends React.Component<{
    store: DocumentsImagesStoreAbstract<any>,
    openCreateExternal: () => void,
    openFillTemplate: () => void,
}> {
    dropdownEl = null;

    render() {
        return (
            <>
                <Dropdown closeOnBodyClick={false} buttonStyle={{ paddingLeft: 10, paddingRight: 10 }} ref={el => this.dropdownEl = el} className='ik-button-secondary--subtle'>
                    <i className="iki iki-more" />
                    <div className="no-select">
                        {(kuura.hasPrivilege('PROJECT_W') && this.props.openCreateExternal) && <>
                            <div className="dropdown-list-title">{__('general.actions')}:</div>
                            <ul className="dropdown-list clickable" onClick={() => this.dropdownEl.close(true)}>
                                <li onClick={this.props.openFillTemplate}><i className="iki iki-edit"></i><span>{__('js_files.fill_template')}</span></li>
                                <li onClick={this.props.openCreateExternal}><i className="iki iki-files"></i><span>{__('js_files.new_external_document')}</span></li>
                            </ul>
                        </>}
                        <div>
                            <div className="dropdown-list-title">{__('general.icon_size')}:</div>
                            <ul className="dropdown-list clickable">
                                <li onClick={() => this.setIconScale(1)}><input type="radio" checked={this.props.store.iconScale == 1} readOnly />{__('general.size.normal')}</li>
                                <li onClick={() => this.setIconScale(1.35)}><input type="radio" checked={this.props.store.iconScale == 1.35} readOnly />{__('general.size.large')}</li>
                            </ul>
                        </div>
                        <div className='dropdown-list-title'>{__('general.sort')}:</div>
                        <ul className='dropdown-list clickable'>
                            <li onClick={() => this.setSort('date')}><input type='radio' checked={this.props.store.sortKey == 'date'} readOnly />{__('general.date')}</li>
                            <li onClick={() => this.setSort('name')}><input type='radio' checked={this.props.store.sortKey == 'name'} readOnly />{__('general.name')}</li>
                        </ul>
                    </div>
                </Dropdown>
            </>
        );
    }

    setSort(sort: 'name' | 'date') {
        this.props.store.sortKey = sort;
    }

    setIconScale(scale: number) {
        this.props.store.iconScale = scale;
    }
}

